import { jsx as _jsx } from "react/jsx-runtime";
import { required, SelectInput } from "react-admin";
import { useWatch } from "react-hook-form";
export var ManagedSelectInput = function (_a) {
    var source = _a.source, label = _a.label, choices = _a.choices, defaultValue = _a.defaultValue, sourceToWatch = _a.sourceToWatch, isDisabled = _a.isDisabled;
    var sourceToWatchStatus = useWatch({ name: sourceToWatch !== null && sourceToWatch !== void 0 ? sourceToWatch : "" });
    return (_jsx(SelectInput, { source: source, choices: choices, label: label, disabled: isDisabled === null || isDisabled === void 0 ? void 0 : isDisabled(sourceToWatchStatus), defaultValue: defaultValue, validate: required(), style: { flex: 1 } }));
};
